import { Skeleton } from "antd"

const SelectCabinClassSkeleton = () => {

  return (
    <Skeleton.Button
      block
      size='large'
      style={{ marginTop: 15 }}
      active
    />
  )
}

export default SelectCabinClassSkeleton